import { render, staticRenderFns } from "./FormControlDynamicSector.vue?vue&type=template&id=6fbb0c64"
import script from "./FormControlDynamicSector.vue?vue&type=script&lang=js"
export * from "./FormControlDynamicSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fbb0c64')) {
      api.createRecord('6fbb0c64', component.options)
    } else {
      api.reload('6fbb0c64', component.options)
    }
    module.hot.accept("./FormControlDynamicSector.vue?vue&type=template&id=6fbb0c64", function () {
      api.rerender('6fbb0c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Form/Control/FormControlDynamicSector.vue"
export default component.exports